module.exports = __webpack_public_path__ + "img/hybrid-cloud-inf.b582660a.webp";